import React, { useState } from 'react'
import { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { AutoComplete, Form, InputPicker, SelectPicker, Table, TagPicker } from 'rsuite';
import queueService from '../../../../services/Internal/Queue/queue.service';
import { getAllCredentials, getCredTypes } from '../../../../services/Shared/codeTable.service';

function AppGridSearch(props) {
    const [applicationTypes, setApplicationTypes] = useState([]);
    const [credType, setCredType] = useState([]);
    const [creds, setCreds] = useState();

    useEffect(() => {
        getCredTypes().then(setCredType);
        if (props.propsIsActive) {
            queueService.getApplicationTypes().then((response) => {
                setApplicationTypes(response.data.map((x, i) => { return { "label": `${x}`, "value": `${x}` } }));
            })
        }
    }, [props.propsIsActive])
    const updateCreds = (value) => {
        getAllCredentials(value).then(setCreds);
    }
    return (
        <Form formValue={props.searchModel} onChange={props.setSearchModel} onSubmit={props.handleSearch} fluid>

            <Row>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Date Range</b></Form.ControlLabel>
                        <Form.Control name="dateSubmittedBegin" type="date" block />
                    </Form.Group>
                </Col>
                <Col xs="auto" style={{ marginTop: '1.5em' }} className="d-flex align-items-center">to</Col>
                <Col>
                    <Form.ControlLabel>&nbsp;</Form.ControlLabel>
                    <Form.Control name="dateSubmittedEnd" type="date" block />
                </Col>
                <Col>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>First Name</b></Form.ControlLabel>
                        <Form.Control name="firstName" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Last Name</b></Form.ControlLabel>
                        <Form.Control name="lastName" />
                    </Form.Group>
                </Col>
                <Col>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Credential Type</b></Form.ControlLabel>
                        <Form.Control
                            name="credentialType"
                            block="true"
                            data={credType}
                            accepter={SelectPicker}
                            searchable={false}
                            placeholder="Select Type"
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Credential #</b></Form.ControlLabel>
                        <Form.Control
                            accepter={AutoComplete}
                            block="true"
                            data={creds}
                            name="credentialNumber"
                            placeholder="Credential #"
                            onChange={updateCreds}
                        />
                    </Form.Group>
                </Col>
            </Row>
            {props.gridType == 'received' &&
                <Row className="mt-2">
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel><b>Application Type</b></Form.ControlLabel>
                            <Form.Control
                                block
                                accepter={TagPicker}
                                data={applicationTypes}
                                name="applicationType" />
                        </Form.Group>
                    </Col>
                </Row>
            }
            <hr />

            <div style={{ textAlign: 'right' }}>
                <Button type="submit">Search</Button>
            </div>
        </Form>
    );
}

export default AppGridSearch;